/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Of_Landing_TitleInputs */

const en_of_landing_title = /** @type {(inputs: Of_Landing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Work from anywhere. Still feel together.`)
};

const id_of_landing_title = /** @type {(inputs: Of_Landing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekerja dari mana saja. Tetap terasa bersama.`)
};

/**
* | output |
* | --- |
* | "Work from anywhere. Still feel together." |
*
* @param {Of_Landing_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const of_landing_title = /** @type {((inputs?: Of_Landing_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Of_Landing_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_of_landing_title(inputs)
	return en_of_landing_title(inputs)
});